import { gql } from "@apollo/client/core";

export const SUBSCRIBE_PRODUCTS = gql`
  subscription GetAllProducts(
    $limit: Int = null
    $offset: Int = null
    $order_by: [products_order_by!] = {}
    $where: products_bool_exp = {}
  ) {
    products(
      limit: $limit
      offset: $offset
      order_by: $order_by
      where: $where
    ) {
      id
      serial_number
      created_at
      status
      registered_at
      unregistered_at
      vehicle_id
      vehicle {
        uuid
        name
      }
      company {
        uuid
        name
      }
      products_product_subscriptions(
        order_by: { start_date: desc }
        limit: 1
      ) {
        end_date
        duration
        start_date
      }
      products_product_subscription_requests(
        where: { status: { _eq: "pending" } }
        limit: 1
      ) {
        id
        status
        requested_duration
        current_end_date
      }
    }
  }
`;

export const SUBSCRIBE_ALL_PRODUCTS_FOR_RENEW = gql`
  subscription GetAllProductsForRenew($where: products_bool_exp = {}) {
    products(where: $where, order_by: { serial_number: asc }) {
      id
      serial_number
      status
      registered_at
      unregistered_at
      vehicle_id
      vehicle {
        uuid
        name
        brand
        model
      }
      company {
        uuid
        name
      }
      products_product_subscriptions(
        order_by: { start_date: desc }
        limit: 1
      ) {
        end_date
        duration
        start_date
      }
      products_product_subscription_requests(
        where: { status: { _eq: "pending" } }
        limit: 1
      ) {
        id
        status
        requested_duration
        current_end_date
      }
    }
  }
`;

export const GET_PRODUCTS_COUNT = gql`
  query GetProductsCount($where: products_bool_exp = {}) {
    products_aggregate(where: $where) {
      aggregate {
        count
      }
    }
  }
`;

export const SUBSCRIBE_PRODUCTS_COUNT = gql`
  subscription GetProductsCount($where: products_bool_exp = {}) {
    products_aggregate(where: $where) {
      aggregate {
        count
      }
    }
  }
`;

export const ASSIGN_VEHICLE_TO_PRODUCT = gql`
  mutation AssignVehicleToProduct(
    $vehicle_id: uuid!
    $id: uuid!
  ) {
    update_products_by_pk(
      _set: { vehicle_id: $vehicle_id }
      pk_columns: { id: $id }
    ) {
      serial_number
    }
  }
`;

export const UPDATE_PRODUCT_STATUS = gql`
  mutation UpdateProductStatus($id: String!, $status: String!) {
    update_products_by_pk(
      _set: { status: $status }
      pk_columns: { id: $id }
    ) {
      id
    }
  }
`;

export const UNREGISTER_PRODUCT = gql`
  query unregisterProduct($company_id: String!, $id: String!) {
    unregister_product(id: $id, company_id: $company_id)
  }
`;

export const DECLINE_PRODUCT = gql`
  query declineProduct($company_id: String!, $id: String!) {
    decline_product(id: $id, company_id: $company_id)
  }
`;

export const INSERT_PRODUCT = gql`
  mutation InsertProduct($product: products_insert_input = {}) {
    insert_products_one(object: $product) {
      serial_number
    }
  }
`;

export const CHECK_PRODUCT_DATA_TO_LOAD = gql`
  query GetProductDataToLoad($uuid: uuid = "") {
    vehicles_by_pk(uuid: $uuid) {
      uuid
      company {
        uuid
        name
      }
    }
  }
`;

export const CHECK_SN_AVAILABILITY = gql`
  query GetSNAvailability($sn: String!) {
    check_serial_number_availability(sn: $sn) {
      error
      isAvailable
    }
    products(where: {unregistered_at: {_is_null: true}, serial_number: {_eq: $sn}}) {
      id
      unregistered_at
    }
  }
`;

export const GET_PRODUCT_CONFIG = gql`
  query GetProductConfig($sn: String = "") {
    get_product_config(sn: $sn) {
      softwareVersion
      hasShockDetection
      horizontalTreshold
      verticalTreshold
    }
  }
`;

export const VALIDATE_RENEWAL_REQUEST = gql`
  mutation ValidateRenewalRequest($input: ValidateRenewalInput!) {
    validate_renewal_request(input: $input)
  }
`;

export const DECLINE_RENEWAL_REQUEST = gql`
  mutation DeclineRenewalRequest($input: DeclineRenewalInput!) {
    decline_renewal_request(input: $input)
  }
`;

export const REQUEST_SUBSCRIPTION_RENEWAL = gql`
  mutation RequestSubscriptionRenewal($renewals: [RenewalRequestInput!]!) {
    request_subscription_renewal(renewals: $renewals)
  }
`;

export const REGISTER_PRODUCT = gql`
  query registerProduct(
    $company_id: String!
    $id: String!
    $duration: String
  ) {
    register_product(company_id: $company_id, id: $id, duration: $duration)
  }
`;
